import React, { Component, lazy, Suspense } from 'react'
import { createPortal } from 'react-dom'
import * as R from 'ramda'
import { Route, Switch } from 'react-router'
import { Element } from 'react-scroll'
import { MOBILE_HEADER_HEIGHT as NAVBAR_HEIGHT } from '@components/navbar'
import Chunk from 'components/Chunk'
import FixedWidget from 'components/FixedWidget'
import {
  PACKAGES_SEGMENT_URI,
  PRODUCT_SEGMENT_URI,
  SALEHOME_SEGMENT_URI,
  SELECTION_SEGMENT_URI
} from 'constants/navigation'
import withDevice from 'hocs/withDevice'
import Error from './Error'
import Footer from './Footer'
import withConnect from './connector'
import { Wrapper } from './style.js'

const Header = lazy(() => import(/* webpackChunkName: "header" */ './Header'))
const loadOffers = () => import(/* webpackChunkName: "catalog" */ './Offers')
const loadProduct = () => import(/* webpackChunkName: "product" */ './Product')
const loadPackagesMobile = () => import(/* webpackChunkName: "packages" */ './Product/mobile')
const loadSelectionMobile = () => import(/* webpackChunkName: "selection" */ './Product/Packages/Selection/index.tsx')
const loadSaleHome = () => import(/* webpackChunkName: "saleHome" */ './SaleHome')

// type Props = {|
//   +device: Device,
//   +isLoggedIn: boolean,
//   +isSaleChanging: boolean,
//   +isSaleFetched: boolean,
//   +locale?: string
// |}

// type State = {| headerHeight: number |}

class Main extends Component {
  constructor (props) {
    super(props)

    this.initialNavBarHeight = props.device.webview ? 0 : NAVBAR_HEIGHT

    this.state = {
      headerHeight: this.initialNavBarHeight
    }
  }

  onHeaderHeightChange = (headerHeight) => {
    if (this.state.headerHeight !== headerHeight) {
      this.setState({ headerHeight: headerHeight || NAVBAR_HEIGHT })
    }
  }

  render () {
    const { isSaleChanging, isLoggedIn, locale, isSaleFetched } = this.props
    const { headerHeight } = this.state

    return (
      <Error>
        <Wrapper data-test-id='main' headerHeight={headerHeight}>
          <If condition={locale && !isSaleChanging}>
            <Suspense fallback={null}>
              <Header onHeightChange={this.onHeaderHeightChange} />
            </Suspense>
            <div className='Main__Container'>
              <If condition={isLoggedIn && isSaleFetched}>
                <Element name='top' style={{ position: 'relative' }}>
                  <Switch>
                    <Route
                      exact
                      path={`/:operationCode/${SALEHOME_SEGMENT_URI}`}
                      render={props => <Chunk {...props} load={loadSaleHome} />}
                    />
                    <Route
                      exact
                      path='/:operationCode/:saleSlug/:universeSlug/:subUniverseSlug?'
                      render={props => (
                        <Chunk
                          {...props}
                          headerHeight={headerHeight}
                          load={loadOffers}
                        />
                      )}
                    />
                    <Route
                      exact
                      path={`/:operationCode/:saleSlug/:universeSlug/:subUniverseSlug?/${PRODUCT_SEGMENT_URI}/:productSlug/${PACKAGES_SEGMENT_URI}/${SELECTION_SEGMENT_URI}`}
                      render={props => <Chunk {...props} load={loadSelectionMobile} />}
                    />
                    <Route
                      exact
                      path={`/:operationCode/:saleSlug/:universeSlug/:subUniverseSlug?/${PRODUCT_SEGMENT_URI}/:productSlug/${PACKAGES_SEGMENT_URI}`}
                      render={props => <Chunk {...props} load={loadPackagesMobile} />}
                    />
                    <Route
                      exact
                      path={`/:operationCode/:saleSlug/:universeSlug/:subUniverseSlug?/${PRODUCT_SEGMENT_URI}/:productSlug`}
                      render={props => <Chunk {...props} headerHeight={headerHeight} load={loadProduct} />}
                    />
                  </Switch>
                </Element>
              </If>
              {createPortal(<Footer />, document.getElementById('portal-footer'))}
              <FixedWidget />
            </div>
          </If>
        </Wrapper>
      </Error>
    )
  }
}

export default R.compose(
  withConnect,
  withDevice
)(Main)
